@for (option of filteredFilterCriterium.values; track option; let i = $index) {
  <!-- titles -->
  <mat-checkbox
    mat-list-item
    class="checkbox-filter__title"
    color="primary"
    [class.checkbox-filter__item--hidden]="
      maxVisibleItems &&
      i >= maxVisibleItems &&
      !showMoreItems &&
      !option.selected &&
      !indeterminateStatus[option.data.id]
    "
    [value]="option"
    [checked]="option.selected"
    [indeterminate]="indeterminateStatus[option.data.id]"
    (change)="onChange($event)"
    data-cy="checkbox-filter-value"
    ><span class="ui-body-1 checkbox-filter__item__name">{{ getDisplayValue(option) }}</span
    >@if (option.prediction) {
    <span class="ui-caption checkbox-filter__item__prediction">
      {{ ' (' + option.prediction + ')' }}</span
      >
      }</mat-checkbox
      >
      <!-- children -->
      @if (option.child) {
        <campus-checkbox-filter
          class="checkbox-filter__items"
    [class.checkbox-filter__item--hidden]="
      maxVisibleItems &&
      i >= maxVisibleItems &&
      !showMoreItems &&
      !option.selected &&
      !indeterminateStatus[option.data.id]
    "
          [criterium]="option.child"
          [maxVisibleItems]="maxVisibleItems"
          [parentValueRef]="option"
          [sortBySelection]="sortBySelection"
          (selectionChanged)="onChildChange($event)"
          >
        </campus-checkbox-filter>
      }
    }
    <!-- show more titles ? -->
    @if (showMoreStatus) {
      <a
        (click)="toggleShowMore()"
        class="checkbox-filter__footer"
        data-cy="checkbox-filter-more-toggle"
        >
        <campus-icon
          [svgIcon]="'arrow-back'"
          [class.rotate--up]="showMoreItems"
          [class.rotate--down]="!showMoreItems"
        ></campus-icon>
        {{ !showMoreItems ? 'toon meer...' : 'toon minder...' }}
      </a>
    }
